import { HDDetailsRequest, HDDetailsResponse } from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class HdDetails<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags HdDetails
	 * @name HdDetails
	 * @request POST:/store/{storeId}/cart/@self/hd_details
	 * @response `200` `HDDetailsResponse` Details updated successfully
	 */
	hdDetails = (
		storeId: string,
		data: HDDetailsRequest,
		query?: {
			/** @example "-5" */
			langId?: string;
			/** @example "json" */
			responseFormat?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (loggerCan('trace') && (!this.http.traceDetails || this.http.traceDetails['hdDetails'])) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/cart/@self/hd_details`,
				params: _params,
				query: query,
				body: data,
				methodName: 'hdDetails',
			};
			logger.trace(traceData);
		}
		return this.http.request<HDDetailsResponse, any>({
			path: `/store/${storeId}/cart/@self/hd_details`,
			method: 'POST',
			query: query,
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
